export default __webpack_public_path__ + "static/media/logo-zefi.0f5d1b90.png";